export enum CivilityTypes {
  MRS = 'mrs',
  MR = 'mr'
}
